import { useMutation, useQueryClient } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { toast } from "sonner";

export const useSortRoomTypes = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (roomTypeIds: string[]) => {
            const response = await privateApi.post("/v4/room-type/sort", {
                room_type_ids: roomTypeIds
            });
            return response.data;
        },
        onSuccess: () => {
            // Invalidate the rooms and rates query to trigger a fresh refetch
            queryClient.invalidateQueries({ queryKey: ["rooms", "rates"] });
            toast.success("Room type sorting updated successfully!");
        },
        onError: (error: any) => {
            console.error("Failed to sort room types:", error);
            const errorMessage = error.response?.data?.message || "Failed to update room type order.";
            toast.error(errorMessage);
        }
    });
};
